import { Avatar, Col } from 'antd';
import { observer } from 'mobx-react-lite';
import React from 'react';
import styled from 'styled-components';
import { userStore } from '@tools/ui-stores';
import { theme } from '@tools/ui-utils/theme.util';

const AvatarStyle = styled(Avatar)`
  margin-top: 32px;
  margin-bottom: 16px;
`;

const PersonalDetailsContainer = styled.div`
  text-align: center;
`;

const ColUserName = styled(Col)`
  font-weight: 600;
  font-size: 16px;
`;

const ColEmail = styled(Col)`
  font-weight: 400;
  font-size: 14px;
  margin-top: 2px;
  margin-bottom: 23px;
  color: ${theme.colors.gray.gray70};
`;

const PersonalDetails: React.FC<React.PropsWithChildren> = observer(() => {
  const { currentUser } = userStore;

  return (
    <PersonalDetailsContainer>
      <AvatarStyle size={60} src={currentUser?.picture} />
      <ColUserName>{currentUser?.name}</ColUserName>
      <ColEmail>{currentUser?.email}</ColEmail>
    </PersonalDetailsContainer>
  );
});

export default PersonalDetails;
